import agency from './agency';
import park from './park';
import driver from './driver';
import devmnt from './devmnt';
import passpotok from './passpotok';
import devgsm from './devgsm';
import typecamera from './typecamera';
import devcamera from './devcamera';
import transporttype from './transporttype';
import capacitytype from './capacitytype';
import stop from './stop';
import marshtype from './marshtype';
import route from './route';
import rtrip from './trip';
import tripstops from './tripstops';
import holidays from './holidays';
import sroutevars from './sroutevars';
import svehicletask from './vehicletask';
import replacevehicle from './replacevehicle';
import validator from './validator';
import district from './district';
import department from './department';
import controlregion from './controlregion';
import vcontrollerequipmenttype from './controllerequipmenttype';
import controllerequipment from './controllerequipment';
import controllercard from './controllercard';
import ticketview from './ticketview';
import tickettype from './tickettype';
import graphictype from './graphictype';
import incidents from './incidents';
import vehicle from './vehicleNEW';
import edevmnttype from './devmnttype';
import raspvariants from './raspvariants';
import devdvr from './devdvrNEW';
import rasptime from './rasptime';
import dvrtypes from './devmnttypeNEW';
import geozonesdm from './geozonesdm';
import vehdrivers from './vehicledriver';
import accelerometerParams from './accelerometerParams';
import speedLimit from './speedLimit';
import dqagroups from './dqagroups';
import vehiclemodel from './vehiclemodel';
import asmppsensormodel from './asmppsensormodel';
import devtempsenstypes from './devtempsenstypes';
import ispv from './ispv';
import blemarkslist from './blemarkslist';
import blemarkstypes from "./blemarkstypes";
import blemarkssettings from "./blemarkssettings";
import blemarksparameters from "./blemarksparameters";
import blemarksidentifierregistry from "./blemarksidentifierregistry";
import notificationsending from "./notificationsending";

export default {
  ispv,
  blemarkslist,
  blemarkstypes,
  blemarkssettings,
  blemarksparameters,
  blemarksidentifierregistry,
  geozonesdm,
  dqagroups,
  vehdrivers,
  vehicle,
  devdvr,
  dvrtypes,
  agency,
  park,
  driver,
  edevmnttype,
  devmnt,
  passpotok,
  devgsm,
  // devaccel,
  typecamera,
  devcamera,
  transporttype,
  capacitytype,
  stop,
  marshtype,
  route,
  sroutevars,
  rtrip,
  tripstops,
  holidays,
  raspvariants,
  rasptime,
  svehicletask,
  replacevehicle,
  controllerequipment,
  controllercard,
  ticketview,
  tickettype,
  validator,
  district,
  department,
  controlregion,
  vcontrollerequipmenttype,
  racestops: {
    title: 'Связь маршрутов, рейсов и остановочных пунктов',
  },
  stimevars: {
    title: 'Связь вариантов расписаний и плановых отправлений по ОП',
  },
  graphictype,
  incidents,
  accelerometerParams,
  speedLimit,
  vehiclemodel,
  asmppsensormodel,
  devtempsenstypes,
  notificationsending,
} as { [key: string]: any };
